import { disableScroll, enableScroll } from '@/shared/helpers/helpers';

export class HeaderMenu {
	private element: HTMLElement;
	private opener: HTMLButtonElement;
	private readonly activeClass: string = 'header-menu--active';
	private isOpen: boolean = false;

	constructor(element) {
		if (!element) return;
		this.element = element;
		this.opener = this.element.querySelector('.header-menu__button');

		this.init();
	}

	public open = (): void => {
		disableScroll();
		this.isOpen = true;
		this.element.classList.add(this.activeClass);
	};

	public close = (): void => {
		enableScroll();
		this.isOpen = false;
		this.element.classList.remove(this.activeClass);
	};

	private handleClick = ({ target, currentTarget }): void => {
		if (target === currentTarget) this.close();
		else if (this.opener.contains(target) && this.isOpen) this.close();
		else if (this.opener.contains(target) && !this.isOpen) this.open();
	};

	public init = (): void => {
		this.element.addEventListener('click', this.handleClick);
	};
}
